import { render, staticRenderFns } from "./YoneticiTanimla.vue?vue&type=template&id=00efa672&scoped=true&"
import script from "./YoneticiTanimla.vue?vue&type=script&lang=js&"
export * from "./YoneticiTanimla.vue?vue&type=script&lang=js&"
import style0 from "./YoneticiTanimla.vue?vue&type=style&index=0&id=00efa672&lang=scss&scoped=true&"
import style1 from "./YoneticiTanimla.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00efa672",
  null
  
)

export default component.exports